import { render, staticRenderFns } from "./ActivateUser.vue?vue&type=template&id=f218fc60&scoped=true&"
import script from "./ActivateUser.vue?vue&type=script&lang=js&"
export * from "./ActivateUser.vue?vue&type=script&lang=js&"
import style0 from "./ActivateUser.vue?vue&type=style&index=0&id=f218fc60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f218fc60",
  null
  
)

export default component.exports